"use strict";

import { Box, Heading, Stack } from '@autoguru/overdrive';
import clsx from 'clsx';
import * as styles from './BoxedMessageScreen.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BoxedMessageScreen = _ref => {
  let {
    title,
    children,
    className = '',
    imgUrl,
    illustration,
    boxed = true
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    "aria-disabled": "true",
    borderWidth: boxed ? '1' : 'none',
    borderRadius: "md",
    borderColour: "light",
    paddingY: ['2', '3'],
    paddingX: ['2', '3'],
    className: clsx(styles.root, className),
    children: /*#__PURE__*/_jsxs(Stack, {
      width: "full",
      space: "2",
      alignItems: "center",
      children: [imgUrl && /*#__PURE__*/_jsx("img", {
        className: styles.successImage,
        src: imgUrl,
        alt: "Success"
      }), illustration, /*#__PURE__*/_jsxs(Stack, {
        width: "full",
        space: "5",
        children: [title ? /*#__PURE__*/_jsx(Heading, {
          is: "h2",
          children: title
        }) : null, children]
      })]
    })
  });
};